// ----------------------------------------------------------------------
// <copyright file="Izenda.TextTileToolbar.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * TextTileToolbar component
 */
!(function () {
  var React = require('react');
  var observer = require('mobx-react').observer;

  var FontFormat = require('share/components/controls/Izenda.FontFormat');
  var ColorStyling = require('share/components/controls/Izenda.ColorStyling');
  var ButtonGroup = require('share/components/controls/Izenda.ButtonGroup');
  var FORMAT_CONFIG = require('logic/data/Izenda.ReportPartFormConstants').FORMAT_CONFIG;

  var TOOLBAR_BUTTON_CONFIG = require('logic/data/Izenda.DashboardTextTileToolbarConstants');
  var BUTTON_STYLE =  TOOLBAR_BUTTON_CONFIG.BUTTON_STYLE;
  var BUTTON_ALIGN = TOOLBAR_BUTTON_CONFIG.BUTTON_ALIGN;
  var BUTTON_ALIGN_VERTICAL = TOOLBAR_BUTTON_CONFIG.BUTTON_ALIGN_VERTICAL;
  var BUTTON_LIST = TOOLBAR_BUTTON_CONFIG.BUTTON_LIST;
  var BUTTON_INDENT = TOOLBAR_BUTTON_CONFIG.BUTTON_INDENT;

  var TextTileToolbar = function (props) {

    var dashboardPart = props.dashboardPart;
    var config = props.config;

    function handleChangeFont (data, item) {
      switch(item.keyChange) {
        case 'fontFamily':
          var fontFamily = FORMAT_CONFIG.FONT_NAME[data.value.fontFamily];
          props.onExecCommand('FontName', fontFamily);
          break;
        case 'fontSize':
          var fontSize = data.value.fontSize + 'px';
          props.onExecCommand('FontSize', fontSize);
          break;
      }
    }

    function handleChangeColor (data, item) {
      switch(item.keyChange) {
        case 'textColor':
          props.onApplyFormat('forecolor', data.value.textColor);
          break;
        case 'backgroundColor':
          props.onApplyFormat('hilitecolor', data.value.backgroundColor);
          break;
      }
    }

    function handleChangeAlignVertical (data) {
      var value = data && data.value;
      dashboardPart.setVerticalAlignConfig(value);
    }

    function handleChangeFormatButton (item) {
      props.onToggleFormat(item.value)
    }

    return (
      <div className="izenda-DashboardTile-TextTileFrontSide-Toolbar">
        <FontFormat
          className="u_inlineBlock u_floatLeft"
          onChange={handleChangeFont}
          value={config} />
        <ButtonGroup
          className="u_inlineBlock"
          buttons={BUTTON_STYLE}
          onChange={handleChangeFormatButton}
          value={config} />
        <ColorStyling
          className="u_inlineBlock izenda-DashboardTile-TextTileFrontSide-Toolbar-ColorStyling"
          onChange={handleChangeColor}
          value={config} />
        <ButtonGroup
          className="u_inlineBlock"
          buttons={BUTTON_ALIGN}
          onExecCommand={props.onExecCommand}
          value={config} />
        <ButtonGroup
          className="u_inlineBlock"
          buttons={BUTTON_ALIGN_VERTICAL}
          value={config}
          onChange={handleChangeAlignVertical} />
        <ButtonGroup
          className="u_inlineBlock"
          buttons={BUTTON_LIST}
          applyListFormat={props.onApplyListFormat}
          value={config} />
        <ButtonGroup
          className="u_inlineBlock"
          buttons={BUTTON_INDENT}
          onExecCommand={props.onExecCommand}
          value={config} />
      </div>
    )
  };

  TextTileToolbar.propTypes = {
    onExecCommand: React.PropTypes.func.isRequired,
    onApplyFormat: React.PropTypes.func.isRequired,
    config: React.PropTypes.object.isRequired
  };

  module.exports = TextTileToolbar;
}());



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/TextTile/Izenda.TextTileToolbar.jsx